import type { TimeFormat } from '@app/api/Branches/types';
import type { TEmployee, NAnalytics } from '@app/types';
import type { NUsers } from '@app/types/Users';

import type { BaseOptionType } from 'antd/es/select';

export namespace NSchedule {
  export interface ScheduleInitialState {
    currentDate: Date;
  }

  export type ModelWorkSchedule = {
    Id: number;
    UserId: NUsers.User['id'];
    BranchId: number;
    TimeS: string;
    TimeE: string;
    IsIgnoreRecords: boolean;
  };

  export type ModelWorkBreak = {
    Id: number;
    UserId: NUsers.User['id'];
    BranchId: number;
    TimeS: string;
    TimeE: string;
  };

  export interface BranchWorkTimeInterface {
    BranchId: number;
    Timezone: string | null;
    Date: string;
    WorkTimeE: string;
    WorkTimeS: string;
    JournalFormatTime: TimeFormat;
  }

  export type ModelBranchWorkTime = BranchWorkTimeInterface;

  export type ModelEmployeeDateWorkSchedule = {
    UserId: number;
    NameFirst: string | null;
    NameLast: string | null;
    Date: string;
    WorkSchedule: ModelWorkSchedule;
    WarningForEdit: string | null;
    WarningForDelete: string | null;
    BranchWorkTime: BranchWorkTimeInterface;
  };

  export type ModelCheckEmployeeWorkSchedule = {
    UserId: number;
    NameFirst: string | null;
    NameLast: string | null;
    WarningForEdit: string | null;
    WarningForDelete: string | null;
  };

  export type ModelCheckEmployeeWorkBreak = {
    UserId: number;
    NameFirst: string | null;
    NameLast: string | null;
    WarningForEdit: string | null;
  };

  export type ModelJournalEmployee = {
    Id: number;
    UserId: number;
    NameLast: string | null;
    NameFirst: string | null;
    NameFull: string | null;
    Photo: string | null;
    PositionId: number | null;
    Position: string | null;
    WorkTimeS: string | null;
    WorkTimeE: string | null;
  };

  export type InsertInSortedArray = (
    arr: BaseOptionType[],
    item?: TEmployee
  ) => TEmployee[];

  export type SetTypicalDataByEmployees = (data: TEmployee[]) => void;

  export type AddEmployeeModal = (args: {
    isModalLoading: boolean;
    isModalOpen: boolean;
    userId: number | null;
    database: string | null;
    activeBranchId: number | null;
    dateString: string;
    employeesWithoutWorkSchedule: ModelJournalEmployee[];
    setEmployeesWithoutWorkSchedule: (value: ModelJournalEmployee[]) => void;
    setIsModalOpen: (value: boolean) => void;
    setEmployeeDetails: SetTypicalDataByEmployees;
    setAllEmployees: SetTypicalDataByEmployees;
    setSelectedEmployees: SetTypicalDataByEmployees;
    insertInSortedArray: InsertInSortedArray;
  }) => JSX.Element;

  export type AddWorkScheduleModal = (args: {
    employeeId: number;
    onSuccess?: () => void;
  }) => JSX.Element;

  export type FinancialStatisticsDropdownItemsProps = {
    financialStatistics: NAnalytics.ModelFinancialStatistic | undefined;
    isCalendarComponent: boolean;
  };

  export type EditingWorkScheduleFormProps = {
    timeS: number | undefined;
    timeE: number | undefined;
  };
}
